import { render, staticRenderFns } from "./ComplaintFiles.vue?vue&type=template&id=77a6fd2d&"
import script from "./ComplaintFiles.vue?vue&type=script&lang=js&"
export * from "./ComplaintFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports